/*
 * Copyright (C) 2022 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable } from '@angular/core';

export type ResizeObserverSingleEntryCallback = (entry: ResizeObserverEntry) => void;

/**
 * For optimization purposes provides instance of ResizeObserver shared across all responsive pill list components.
 */
@Injectable({
  providedIn: 'root'
})
export class ResponsivePillListResizeService {

  private readonly callbacks = new Map<Element, ResizeObserverSingleEntryCallback>();
  private readonly resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      this.callbacks.get(entry.target)?.(entry);
    }
  });

  observe(target: Element, callback: ResizeObserverSingleEntryCallback): void {
    this.callbacks.set(target, callback);
    this.resizeObserver.observe(target);
  }

  unobserve(target: Element): void {
    this.callbacks.delete(target);
    this.resizeObserver.unobserve(target);
  }
}
